import styles from "./ContentConfirmation.module.css"
import { resumeLabelMap } from "./constants"
import React, { useContext } from "react"
import { StepContext } from "../../StepContainer"

export const UserWebResume = () => {
    const { displayState } = useContext(StepContext)

    return (
        <div className={styles.accordionContentInner}>
            <div className={styles.infoGroup}>
                <h3>WEB職務経歴書1社目</h3>
                <div className={styles.resumeInfoUp}>
                    <div className={styles.resumeRow}>
                        <span className={styles.resumeLabel}>
                            {resumeLabelMap.companyName}
                        </span>
                        <span className={styles.resumeValue}>
                            {displayState.companyName}
                        </span>
                    </div>
                    <div className={styles.resumeRow}>
                        <span className={styles.resumeLabel}>
                            {resumeLabelMap.workStartDate}
                        </span>
                        <span className={styles.resumeValue}>
                            {displayState.workStartDate}
                        </span>
                    </div>
                    <div className={styles.resumeRow}>
                        <span className={styles.resumeLabel}>
                            {resumeLabelMap.workEndDate}
                        </span>
                        <span className={styles.resumeValue}>
                            {displayState.workEndDate}
                        </span>
                    </div>
                    <div className={styles.resumeRow}>
                        <span className={styles.resumeLabel}>
                            {resumeLabelMap.employment}
                        </span>
                        <span className={styles.resumeValue}>
                            {displayState.employment}
                        </span>
                    </div>
                    <div className={styles.resumeRow}>
                        <span className={styles.resumeLabel}>
                            {resumeLabelMap.genre}
                        </span>
                        <span className={styles.resumeValue}>
                            {displayState.genre}
                        </span>
                    </div>
                </div>
                <div className={styles.resumeInfoUp}>
                    <div className={styles.resumeRow}>
                        <span className={styles.resumeLabel}>
                            {resumeLabelMap.occupation}
                        </span>
                        <span className={styles.resumeValue}>
                            {displayState.occupation}
                        </span>
                    </div>
                </div>
                <div className={styles.resumeInfoLow}>
                    <div className={styles.resumeWorkDetailLabel}>
                        {resumeLabelMap.detailedJobDetails}
                    </div>
                    <p className={styles.text_linefeed}>
                        {displayState.detailedJobDetails}
                    </p>
                </div>
            </div>
        </div>
    )
}
